/** @jsxImportSource theme-ui */
import classNames from 'classnames';
import React, { useContext, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { ThemeUIStyleObject } from 'theme-ui';

import { AppStateContext } from 'api/AppStateContext';
import { sxtheme } from 'utils/cssHelpers';

import MapContainer from 'map/MapContainer';

import { CovidDisclaimer } from 'components/Navigationbar/CovidDisclaimer';
import DashboardToolbar from 'components/Navigationbar/DashboardToolbar';
import { EventView } from 'components/SidebarView/EventView';

import LocationsContainer from 'locations/LocationsContainer';

const Styles: ThemeUIStyleObject = {
  display: 'flex',
  flex: 1,
  minHeight: 0,
  flexDirection: 'column',
  '& .dashboard-toolbar-wrapper': { display: ['none', 'initial'], flex: 0 },
  '& .sidebar-view-container': {
    display: 'flex',
    minHeight: 0,
    flex: 1,
    '& .sidebar': {
      position: 'relative', // position: "absolute" // FIX: 052b632d: this fix also works, maybe revisit and do instead of pointer-events: none
      height: '100%',
      bg: sxtheme(t => t.colors.stone10),
      pointerEvents: 'all',
      width: ['100%', 'initial'],
      display: 'flex',
      overflowX: 'auto',
      maxWidth: ['100%', 'calc(100vw - 200px)'],
    },
    '& .map-container': {
      flex: 1,
      display: ['none', 'block'],
      height: '100%',
      position: 'relative',
      '&.map-hidden': { display: 'none' },
    },
  },
};

const Sidebar: React.FC = () => {
  const { appState } = useContext(AppStateContext);
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  const isSidebarHidden = !appState.isMapHidden && appState.isSidebarCollapsed === true;
  // Explicitly === false because sidebar contains settings and settings would no longer be fullscreen
  const isSidebarExpanded = !appState.isMapHidden && appState.isSidebarCollapsed === false;

  return (
    <div sx={Styles}>
      {showDisclaimer && <CovidDisclaimer onClose={() => setShowDisclaimer(false)} />}
      <DashboardToolbar showToolbar />
      <div className="sidebar-view-container">
        <div
          id="sidebar"
          data-testid="sidebar"
          className={classNames({
            sidebar: true,
            'bd-sidebar-slide-out': isSidebarHidden,
            'bd-sidebar-slide-in': isSidebarExpanded,
            'map-hidden': appState.isMapHidden,
          })}
          hidden={isSidebarHidden}
        >
          <Routes>
            <Route path="all/*" element={<EventView />} />
            <Route path="location/*" element={<LocationsContainer />} />
            <Route path="*" element={<Navigate to="/settings/notifications" replace />} />
          </Routes>
        </div>
        <MapContainer />
      </div>
    </div>
  );
};

export default Sidebar;
